/**
 * Temas estacionales de la carta — Portal Cliente
 *
 * Responsabilidad: obtener el tema vigente de una sucursal.
 * La vigencia (fechas, activo, prioridad) se resuelve en el servidor.
 *
 * Consume: rpc_tema_estacional_carta_activo.
 */

import { supabase } from "../supabaseClient";

/**
 * @typedef {Object} TemaEstacionalCarta
 * @property {string} id
 * @property {string} clave
 * @property {string} nombre
 * @property {number} prioridad
 * @property {string} inicia_en
 * @property {string} termina_en
 * @property {string|null} sucursal_id
 * @property {Object} config
 */

/**
 * Tema visual activo para la carta de una sucursal, o null si no hay ventana vigente.
 *
 * @param {string} sucursalId
 * @returns {Promise<TemaEstacionalCarta|null>}
 */
export async function obtenerTemaEstacionalActivo(sucursalId) {
  if (!sucursalId) {
    return null;
  }

  const { data, error } = await supabase.rpc(
    "rpc_tema_estacional_carta_activo",
    { p_sucursal_id: sucursalId }
  );

  if (error) {
    throw error;
  }

  if (!data || typeof data !== "object" || !data.clave) {
    return null;
  }

  return {
    id: String(data.id),
    clave: String(data.clave),
    nombre: String(data.nombre || ""),
    prioridad: Number(data.prioridad) || 0,
    inicia_en: data.inicia_en ?? null,
    termina_en: data.termina_en ?? null,
    sucursal_id: data.sucursal_id ? String(data.sucursal_id) : null,
    config:
      data.config && typeof data.config === "object" ? data.config : {},
  };
}
